import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpResponse,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { Observable, of, throwError } from "rxjs";
import {
  delay,
  mergeMap,
  materialize,
  dematerialize,
  finalize,
} from "rxjs/operators";
import { LoadingService } from "../services/loading.service";

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  loadingService: LoadingService;

  constructor(loadingService: LoadingService) {
    this.loadingService = loadingService;
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    var loaderName = new Date().toISOString();
    this.loadingService.push_a_loading(loaderName);

    return next.handle(request).pipe(
      finalize(() => {
        this.loadingService.remove_a_loading(loaderName);
      })
    );
  }
}
